module.exports = __webpack_public_path__ + "static/media/slide7.1bd37139.jpg";